import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkoutControls = ({ 
  onPause,
  onResume,
  onFinish,
  onEmergencyStop,
  isPaused = false
}) => {
  const [showEmergencyConfirm, setShowEmergencyConfirm] = useState(false);

  const handleEmergencyStop = () => {
    if (showEmergencyConfirm) {
      onEmergencyStop();
    } else {
      setShowEmergencyConfirm(true);
      setTimeout(() => setShowEmergencyConfirm(false), 3000);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-6">
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant={isPaused ? "default" : "outline"}
          onClick={isPaused ? onResume : onPause}
          className="flex-1"
          iconName={isPaused ? "Play" : "Pause"}
          iconPosition="left"
        >
          {isPaused ? 'Resume Workout' : 'Pause Workout'}
        </Button>

        <Button
          variant="success"
          onClick={onFinish}
          className="flex-1"
          iconName="CheckCircle2"
          iconPosition="left"
        >
          Finish Workout
        </Button>

        <Button
          variant={showEmergencyConfirm ? "danger" : "outline"}
          onClick={handleEmergencyStop}
          className="sm:w-auto"
          iconName="AlertTriangle"
          iconPosition="left"
        >
          {showEmergencyConfirm ? 'Confirm Stop' : 'Emergency Stop'}
        </Button>
      </div>

      {showEmergencyConfirm && (
        <div className="mt-3 p-3 bg-error/10 border border-error/20 rounded-lg">
          <p className="text-xs text-center text-foreground">
            Click "Confirm Stop" again to end workout without saving progress
          </p>
        </div>
      )}

      <div className="mt-4 flex flex-wrap items-center justify-center gap-4 text-xs caption text-muted-foreground">
        <button className="flex items-center gap-1 hover:text-foreground transition-smooth">
          <Icon name="Volume2" size={14} />
          <span>Sound On</span>
        </button>
        <button className="flex items-center gap-1 hover:text-foreground transition-smooth">
          <Icon name="Mic" size={14} />
          <span>Voice Commands</span>
        </button>
        <button className="flex items-center gap-1 hover:text-foreground transition-smooth">
          <Icon name="Settings" size={14} />
          <span>Workout Settings</span>
        </button>
      </div>
    </div>
  );
};

export default WorkoutControls;